import { createContext } from "react";
import type { VideoOverlayContextValue } from "../types";


export const VideoOverlayContext = createContext<VideoOverlayContextValue | undefined>(undefined);